import { Link } from "react-router-dom";
import { Target, FileVideo, UsersRound, GraduationCap, TrendingUp, Handshake } from "lucide-react";
import { useSiteContent } from "@/hooks/useSiteContent";
import { DEFAULTS } from "@/lib/content_defaults";

const ICONS = [<UsersRound/>, <FileVideo/>, <Target/>, <TrendingUp/>, <Handshake/>, <GraduationCap/>];

export default function Recruiting() {
  const { data: hero } = useSiteContent("page_hero_recruiting", DEFAULTS.page_hero_recruiting);
  const { data: pillars } = useSiteContent("recruiting_pillars", DEFAULTS.recruiting_pillars);
  return (
    <div>
      <section className="section-dark py-20">
        <div className="container-app grid md:grid-cols-2 gap-10 items-center">
          <div>
            <div className="label-tag mb-4">{hero.label_tag}</div>
            <h1 className="font-heading font-black uppercase text-5xl md:text-7xl leading-none">
              {hero.line1}<br/><span className="metallic-gold">{hero.line2}</span><br/><span className="metallic-silver">{hero.line3}</span>
            </h1>
            <p className="mt-6 text-white/75 max-w-xl text-lg">{hero.subtitle}</p>
            <div className="mt-8 flex gap-4 flex-wrap">
              <Link to={hero.cta_primary_link} className="btn-gold" data-testid="recruiting-cta-join">{hero.cta_primary_text}</Link>
              <Link to={hero.cta_secondary_link} className="btn-ghost" data-testid="recruiting-cta-pricing">{hero.cta_secondary_text}</Link>
            </div>
          </div>
          <div className="aspect-[4/5] bg-ink-2 border border-white/10 overflow-hidden">
            <img src={hero.hero_image} alt="training" className="w-full h-full object-cover opacity-80"/>
          </div>
        </div>
      </section>
      <section className="section-light py-20">
        <div className="container-app">
          <div className="label-tag mb-3" style={{ color: "#000" }}>{pillars.section_label}</div>
          <h2 className="font-heading font-black uppercase text-4xl md:text-5xl mb-14">{pillars.section_title}</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {(pillars.items || []).map((s, i) => (
              <div key={i} className="card-light p-8 hover-lift">
                <div className="text-[color:var(--gold)]">{ICONS[i % ICONS.length]}</div>
                <div className="font-heading uppercase font-bold text-xl mt-4">{s.title}</div>
                <p className="mt-3 text-neutral-700 leading-relaxed text-sm">{s.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
